import * as React from "react";
import { DateRange, TableColum } from "../../interfaces";
import { getValues, parseTagSanitizeAndWhitelist } from "../../../../helpers/Utils";

export const getNumberCell = (cellValue) => cellValue ?? "-";

export const getRandomCell = (x = 1) => Math.round((Math.random() * 1000) * x);

export const getCell = (column: TableColum, cellValue) => {
	if (typeof cellValue === "boolean") {
		return <span className="glyphicon glyphicon-ok-sign" />;
	}

	if (column?.extra?.valueType === "Link" && typeof cellValue === "string") {
		return (
			<a href={cellValue} target="_blank" rel="noreferrer">
				{cellValue}
			</a>
		);
	}

	switch (column?.type) {
		case "Float":
		case "Number": {
			return cellValue ?? "-";
		}

		case "File": {
			if (!Array.isArray(cellValue)) {
				return null;
			}

			return cellValue.map((file) => {
				const nameIcon = file?.value?.split(".")?.pop()?.toLowerCase() || "unknown";

				return (
					<div key={file?.value}>
						<a download href={file?.url} className="file-grid">
							<span className={`fileicon fileicon-${nameIcon}`} />
							{file?.value}
						</a>
					</div>
				);
			});
		}

		case "CheckBoxSet":
		case "RadioButton": {
			if (typeof cellValue === "number" || typeof cellValue === "string") {
				const findOption = column?.options?.find((option) => option.name === cellValue?.toString());

				return (
					<span className="td-check">
						<span className="glyphicon glyphicon-ok-sign" />
						{findOption?.label}
					</span>
				);
			}
			return column?.options?.map(
				(option) =>
					cellValue?.indexOf(option.name) > -1 && (
						<span key={option.label} className="td-check">
							<span className="glyphicon glyphicon-ok-sign" />
							{option.label}
						</span>
					)
			);
		}

		case "Calendar":
		case "RangedMultiCalendar": {
			if (Array.isArray(cellValue)) {
				return cellValue.map((value: DateRange | string) => {
					if (typeof value === "string") {
						return (
							<div key={value} className="td-dates">
								{value}
							</div>
						);
					}
					return (
						<div key={`${value?.beginDate}_${value?.finishDate}`} className="td-dates">
							{getValues<DateRange>(value)?.join(" - ")}
						</div>
					);
				});
			}

			if (typeof cellValue === "object" && !!cellValue) {
				return getValues<DateRange>(cellValue)?.join(" - ");
			}

			return cellValue;
		}
		// TODO: did not find this type
		case "ConstLink":
			return <a href={cellValue?.link_url}> {cellValue?.link_title} </a>;

		case "TextArea": {
			return <div>{parseTagSanitizeAndWhitelist(cellValue, column?.extra?.allowed_tags)}</div>;
		}

		default:
			return typeof cellValue === "string" && <span>{cellValue}</span>;
	}
};
